import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
    component: Index,
    loader: async () => {
        throw redirect({ to: "/overview" });
    },
});

function Index() {
    return null;
}
